import React, {useEffect, useState} from 'react';
import {
    Container,
    Typography,
    Box,
    Button,
    Grid,
    FormControlLabel,
    Checkbox,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Formik, Form, Field, useFormikContext } from 'formik';
import { TextField, Select, MenuItem, FormControl, InputLabel } from '@material-ui/core';
import {REGIONS, REGIONS_MAP} from "../../../../utils/META/cat_101";
import {ORG_TYPES, ORG_TYPES_MAP} from "../../../../utils/META/cat_102";
import {SECTORS, SECTORS_MAP} from "../../../../utils/META/cat_103";
import {HIST_DURATIONS, HIST_DURATIONS_MAP} from "../../../../utils/META/cat_104";
import useStyles from "../../../../assets/styles/ProgramRatingStyles";
import {IconButton} from "@mui/material";
import EditIcon from "@material-ui/icons/Edit";

const FormTextField = ({ label, name, value, disabled, type = 'text', ...rest }) => {
    const [isFocused, setIsFocused] = useState(false);

    const validateEmailFormat = (email) => {
        if (!email) return 'Email is required';
        const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        return isValid ? undefined : 'Invalid email format';
    };

    return (
        <Field name={name} validate={type === 'email' ? validateEmailFormat : undefined}>
            {({ field, form }) => {
                const hasError = form.touched[name] && form.errors[name];

                return (
                    <TextField
                        {...field}
                        style={{ backgroundColor: '#fff' }}
                        label={isFocused ? '' : label}
                        fullWidth
                        required
                        margin="normal"
                        variant="outlined"
                        type={type}
                        InputLabelProps={{ shrink: value ? true : isFocused }}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => {
                            setIsFocused(false);
                            form.setFieldTouched(name, true);
                        }}
                        disabled={disabled}
                        error={!!hasError}
                        helperText={hasError ? form.errors[name] : null}
                        {...rest}
                    />
                );
            }}
        </Field>
    );
};

const FormSelect = ({ label, name, options, disabled }) => (
    <FormControl fullWidth variant="outlined" margin="normal" required disabled={disabled} style={{backgroundColor:'#fff'}}>
        <InputLabel htmlFor={name}>{label}</InputLabel>
        <Field as={Select} label={label} name={name}>
            {options.map((option, index) => (
                <MenuItem key={index} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </Field>
    </FormControl>
);

const FormComponent = ({ organizationInfo, handleCompanyDataChange, isEditing }) => {
    const classes = useStyles();
    const { values, errors, isValid } = useFormikContext();

    useEffect(() => {
        if (handleCompanyDataChange) {
            handleCompanyDataChange(values);
        }
    }, [values, handleCompanyDataChange]);
    // const [isSameAsOrg, setIsSameAsOrg] = useState(false);
    //
    // useEffect(() => {
    //     if (isSameAsOrg) {
    //         setFieldValue('nameCompany', values.NameOrg);
    //         setFieldValue('nameContactPerson', values.NameContact);
    //
    //     }
    // }, [isSameAsOrg, organizationInfo, setFieldValue]);
    //
    // const handleCheckboxChange = (event) => {
    //     setIsSameAsOrg(event.target.checked);
    //     setFieldValue('sameAsOrgInfo', event.target.checked);
    //
    //     if (!event.target.checked) {
    //         setFieldValue('nameCompany', '');
    //         setFieldValue('nameContactPerson', '');
    //         // setFieldValue('emailContactPerson', '');
    //     }
    // };

    return (
        <Form>
            <Grid container spacing={2}>
                    <FormTextField
                        label="Name of organization"
                        name="NameOrg"
                        value={values.NameOrg}
                        disabled={!isEditing}
                        type="text"
                    />
                    <FormSelect
                        label="Country of organization’s headquarters"
                        name="Region"
                        options={REGIONS}
                        value={values.Region}
                        disabled={!isEditing}
                    />
                <FormSelect
                        label="Type of organization"
                        name="OrgTypes"
                        options={ORG_TYPES}
                        value={values.OrgTypes}
                        disabled={!isEditing}
                    />
                <FormSelect
                        label="Sector of organization"
                        name="Sectors"
                        options={SECTORS}
                        value={values.Sectors}
                        disabled={!isEditing}
                    />
                <FormSelect
                    label="Years organization in operation"
                    name="History"
                    options={HIST_DURATIONS}
                    value={values.History}
                    disabled={!isEditing}
                />
                <FormTextField
                    label="Address of organization"
                    name="AddressOrg"
                    value={values.AddressOrg}
                    disabled={!isEditing}
                    type="text"
                />
                <FormTextField
                    label="Website of organization"
                    name="WebsiteOrg"
                    value={values.WebsiteOrg}
                    disabled={!isEditing}
                    type="text"
                />
                <FormTextField
                    label="Email of organization"
                    name="EmailOrg"
                    value={values.EmailOrg}
                    disabled={!isEditing}
                    type="email"
                />
                <FormTextField
                    label="Name of contact person"
                    name="NameContactPerson"
                    value={values.NameContactPerson}
                    disabled={!isEditing}
                    type="text"
                />
                <FormTextField
                    label="Title of contact person"
                    name="TitleContactPerson"
                    value={values.TitleContactPerson}
                    disabled={!isEditing}
                    type="text"
                />
                <FormTextField
                    label="Email of contact person"
                    name="EmailContactPerson"
                    value={values.EmailContactPerson}
                    disabled={!isEditing}
                    type="email"
                />
                <FormTextField
                    label="Phone number of contact person"
                    name="PhoneContactPerson"
                    value={values.PhoneContactPerson}
                    disabled={!isEditing}
                    type="number"
                />
            </Grid>
            {/*<Box mt={5}>*/}
            {/*    <Typography variant="h4" component="h1" gutterBottom className={classes.infoTitle}>*/}
            {/*        Billing Information*/}
            {/*    </Typography>*/}
            {/*</Box>*/}

            {/*<FormControlLabel*/}
            {/*    control={*/}
            {/*        <Checkbox checked={isSameAsOrg} onChange={handleCheckboxChange} name="sameAsOrgInfo" />*/}
            {/*    }*/}
            {/*    label="Same as Organization Information"*/}
            {/*/>*/}

            {/*<Grid container spacing={2}>*/}
            {/*    <Grid item xs={12} md={6}>*/}
            {/*        <FormTextField label="Name of company" name="nameCompany" variant="outlined" fullWidth value={values.nameCompany} />*/}
            {/*    </Grid>*/}
            {/*    <Grid item xs={12} md={6}>*/}
            {/*        <FormTextField label="Address of company" name="addressCompany" variant="outlined" fullWidth value={values.addressCompany} />*/}
            {/*    </Grid>*/}
            {/*    <Grid item xs={12} md={6}>*/}
            {/*        <FormTextField label="Contact number of company" name="contactCompany" variant="outlined" fullWidth value={values.contactCompany} />*/}
            {/*    </Grid>*/}
            {/*    <Grid item xs={12} md={6}>*/}
            {/*        <FormTextField label="Name of contact person" name="nameContactPerson" variant="outlined" fullWidth value={values.nameContactPerson} />*/}
            {/*    </Grid>*/}
            {/*    <Grid item xs={12} md={6}>*/}
            {/*        <FormTextField label="Email of contact person" name="emailContactPerson" variant="outlined" fullWidth value={values.emailContactPerson} />*/}
            {/*    </Grid>*/}
            {/*    <Grid item xs={12} md={6}>*/}
            {/*        <FormTextField label="Contact number of contact person" name="contactContactPerson" variant="outlined" fullWidth value={values.contactContactPerson} />*/}
            {/*    </Grid>*/}
            {/*</Grid>*/}
            {/*<Box mt={2}>*/}
            {/*    <Button className={classes.badgeButton} type="submit" variant="contained" color="primary">*/}
            {/*        Save*/}
            {/*    </Button>*/}
            {/*</Box>*/}
        </Form>
    );
};

const DQCompanyInfoView = ({ data, actions, options }) => {
    const classes = useStyles();
    const { defaultInitialValues, emptyInitialValues, company_info_exist } = data;
    const { handleCompanyDataChange } = actions;
    const {  } = options;

    const [isEditing, setIsEditing] = useState(!company_info_exist);

    const toggleEdit = () => {
        setIsEditing((prev) => !prev);
    };
    return (
        <Container className={classes.container}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Typography variant="h4" component="h1" gutterBottom className={classes.infoTitle}>
                    Organization Information
                </Typography>
                {company_info_exist && (
                    <IconButton onClick={toggleEdit} aria-label="edit" style={{ marginBottom: '16px' }}>
                        <EditIcon />
                    </IconButton>
                )}
            </Box>
            <Formik
                initialValues={defaultInitialValues}
                validateOnChange={true}
                validateOnBlur={true}
                onSubmit={() => {}}
            >
                {formikProps => (
                    <FormComponent
                        {...formikProps}
                        organizationInfo={defaultInitialValues}
                        handleCompanyDataChange={handleCompanyDataChange}
                        isEditing={isEditing}
                    />
                )}
            </Formik>
        </Container>
    );
};

export default DQCompanyInfoView;